var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<ul class="profile-cal__time-listing gp-cal__day-listing" data-date="' +
__e( cal.moment(start).format('YYYY-MM-DD') ) +
'"> ';
 $.each(events, function (index, event) { ;
__p += ' ' +
((__t = ( cal._event(event) )) == null ? '' : __t) +
' ';
 }); ;
__p += ' </ul>';

}
return __p
};

/*
original source:

<ul class="profile-cal__time-listing gp-cal__day-listing" data-date="<%- cal.moment(start).format('YYYY-MM-DD') %>">
    <% $.each(events, function (index, event) { %>
        <%= cal._event(event) %>
    <% }); %>
</ul>

*/
